<template>
  <div class="white" :class="{'misty' : itemLoading}">
  <v-layout align-center style="cursor:pointer;"   class="py-4 mb-4"  :class="{'pl-4 pr-3' : $vuetify.breakpoint.xsOnly, 'pl-5 pr-2' : !$vuetify.breakpoint.xsOnly}">
    <v-flex shrink @click="showAccounts = !showAccounts">
      <img class="mr-3" style="width:50px;" :src="`data:image/png;base64,${item.logo}`" v-if="item.logo"/>
    </v-flex>
    <v-flex xs6 grow @click="showAccounts = !showAccounts">
      <h2 class="dblock">{{item.name}}</h2>
      <p class="my-0 primary--text">{{numberOfAccounts}}</p>
    </v-flex>
    <v-spacer></v-spacer>
    <v-flex xs3 shrink  @click="showAccounts = !showAccounts">
    <p class="my-0 ml-4 pl-2"><strong>Updated</strong><br>
    {{ formatDateFromNow(item.updated_at) }}</p>
    </v-flex>
    <v-flex shrink align-content-center>
      <v-menu bottom left dense>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon>more_vert</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-tile
              @click="removeItem"
              >
                <v-list-tile-title>Remove </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
    </v-flex>
  </v-layout>
  <div v-if="showAccounts" class="mb-4">
  <v-divider></v-divider>
    <bank-account :account="account" :transactions="transactionsForAccount(account.account_id)" v-for="account in item.accounts" :key="account.account_id"></bank-account>
  </div>
  <confirm ref="confirm"></confirm>
  </div>
</template>

<script>
import BankAccount from '@/components/Shared/BankAccount.vue'
import { formatDate } from '@/components/Mixins/formatDate'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/functions'
import Confirm from '@/components/Shared/Confirm'

export default {
  components: {
    BankAccount,
    Confirm
  },
  props: {
    item: {
      type: Object
    }
  },
  mixins: [formatDate],
  data () {
    return {
      transactions: [],
      showAccounts: false,
      itemLoading: false
    }
  },
  computed: {
    numberOfAccounts () {
      const num = this.item.accounts.length
      if (num > 1) {
        return `${num} accounts`
      } else {
        return `${num} account`
      }
    }
  },
  methods: {
    async loadItemTransactions () {
      this.itemLoading = true
      firebase.database().ref(`bank-transactions/${this.item.groupId}/${this.item.id}`).on('value', (data) => {
        const items = []
        const obj = data.val()
        for (let key in obj) {
          items.push(obj[key])
        }
        this.transactions = items
        this.itemLoading = false
      }, error => {
        console.error(error)
        this.$store.commit('setError', error)
        this.$store.commit('setLoading', false)
      })
    },
    transactionsForAccount (accountId) {
      const accountTransactions = this.transactions.filter(x => x.account_id === accountId)
      return accountTransactions
    },
    async removeItem () {
      if (await this.$refs.confirm.open(`Remove ${this.item.name} connection`, `Are you sure you want to remove a connection to your ${this.numberOfAccounts} with ${this.item.name}?`, { color: 'red' })) {
        this.itemLoading = true
        // firebase function to create new Plaid Item
        const removeItem = firebase.functions().httpsCallable('removeItem')
        try {
          // do the call
          const removeItemResponse = await removeItem({
            itemId: this.item.id,
            groupId: this.item.groupId
          })
          this.itemLoading = false
          this.$store.dispatch('addNotification', { text: `${this.item.name} removed.`, type: 'primary' })
          console.log('removeItemResponse', removeItemResponse.data.status)
          // return removeItemResponse
        } catch (error) {
          this.$store.commit('setError', error)
          this.itemLoading = false
        }
      }
    }
  },
  created () {
    this.loadItemTransactions()
  }
}
</script>
